/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Form, Input, Row, Col, Avatar, Tooltip } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import TextArea from 'antd/lib/input/TextArea';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import UserMenegmentService from '../../../services/UserManagement.service';
import ModalFail from '../../../components/Shared/modal/fail';
import ModalSuccess from '../../../components/Shared/modal/success';
import { useEffect, useState } from 'react';
import IconBack from '../../../assets/Images/icons/icon-back';
import UserService from '../../../services/UserService';
import { ROUTER } from '../../../constants/router';

//import { useHistory } from 'react-router';

//const { Option } = Select;

const AddDepartmentPage = () => {
    const { t, i18n } = useTranslation();
    let { id } = useParams();
    const [form] = Form.useForm();
    const history = useLocation();
    const lang = i18n.language;
    const [openModalStatus, setOpenModalStatus] = useState(undefined);
    const [loading, setLoading] = useState(0);
    const [departmentId, setDepartmentId] = useState('');
    // const [deptCode, setDeptCode] = useState('');
    const [listMember, setListMember] = useState([]);
    const historyName = history.pathname;
    const userIdView = historyName.replace(
        '/user-management/department-list/view-department/',
        ''
    );
    const userIdEdit = historyName.replace(
        '/user-management/department-list/edit-department/',
        ''
    );
    //const history = useHistory();
    const navigate = useNavigate();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const DepartmentDetail = (value) => {
        UserMenegmentService.getDepartmentDetail(value).then((response) => {
            setDepartmentId(response.data.resultData.departmentId);
            form.setFieldsValue({
                departmentEn: response.data.resultData.nameEn,
                departmentTh: response.data.resultData.nameTh,
                departmentCode: response.data.resultData.departmentCode,
                departmentDetail: response.data.resultData.departmentDetail,
            });
            setListMember(response.data.resultData.memberList);
        });
    };

    const role = UserService.role()?.toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);
    useEffect(() => {
        if (!admin) {
            navigate(`/not-found`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [admin]);

    const [isDeptDisable, setIsDeptDisable] = useState(false);

    useEffect(() => {
        if (loading === 0) {
            if (historyName.includes('/view-department') === true) {
                DepartmentDetail(id);
                setIsDeptDisable(true);
            } else if (historyName.includes('/edit-department') === true) {
                if (admin) {
                    setIsDeptDisable(true);
                    DepartmentDetail(id);
                } else {
                    navigate(
                        `${ROUTER.CONFIGURATION.USER_MANAGEMENT}/user-list`
                    );
                }
            } else {
                form.resetFields();
            }
            setLoading(1);
        }
    }, [DepartmentDetail, form, historyName, loading, userIdEdit, userIdView]);

    const onSubmit = async () => {
        const { getFieldsValue } = form;

        const Value = {
            departmentNameEn: getFieldsValue().departmentEn
                ? getFieldsValue().departmentEn
                : '',
            departmentNameTh: getFieldsValue().departmentTh
                ? getFieldsValue().departmentTh
                : '',
            departmentCode: getFieldsValue().departmentCode
                ? getFieldsValue().departmentCode
                : '',
            departmentDetail: getFieldsValue().departmentDetail
                ? getFieldsValue().departmentDetail
                : '',
        };
        const EditValue = {
            departmentId: departmentId ? departmentId : '',
            departmentNameEn: getFieldsValue().departmentEn
                ? getFieldsValue().departmentEn
                : '',
            departmentNameTh: getFieldsValue().departmentTh
                ? getFieldsValue().departmentTh
                : '',
            departmentCode: getFieldsValue().departmentCode
                ? getFieldsValue().departmentCode
                : '',
            departmentDetail: getFieldsValue().departmentDetail
                ? getFieldsValue().departmentDetail
                : '',
        };
        if (historyName.includes('/edit-department') === true) {
            UserMenegmentService.editDepartmentDetail(EditValue)
                .then((res) => {
                    if (res.data.resultMsg === 'SUCCESS') {
                        console.log('success 1');
                        setOpenModalStatus(true);
                    } else {
                        setOpenModalStatus(false);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    // console.log('dup 1');
                    // console.log(err.data.errorData);
                    // console.log(err.data.errorData.code);
                    // console.log(err.data.errorData.msg);
                    if (
                        err.data.errorData.msg ===
                        'ERROR DEPARTMENT CODE IS DUPLICATE'
                    ) {
                        form.setFields([
                            {
                                name: 'departmentCode',
                                errors: [
                                    t('userManagement.DepartmentCodeIsExist'),
                                ],
                            },
                        ]);
                    }
                    if (
                        err.data.errorData.msg ===
                        'ERROR DEPARTMENT NAME EN IS DUPLICATE'
                    ) {
                        form.setFields([
                            {
                                name: 'departmentEn',
                                errors: [
                                    t('userManagement.DepartmentNameIsExist'),
                                ],
                            },
                        ]);
                    }
                    if (
                        err.data.errorData.msg ===
                        'ERROR DEPARTMENT NAME TH IS DUPLICATE'
                    ) {
                        form.setFields([
                            {
                                name: 'departmentTh',
                                errors: [
                                    t('userManagement.DepartmentNameIsExist'),
                                ],
                            },
                        ]);
                    }
                });
        } else {
            UserMenegmentService.saveDepartmentDetail(Value)
                .then((res) => {
                    if (res.data.resultMsg === 'SUCCESS') {
                        console.log('success 2');
                        setOpenModalStatus(true);
                    } else {
                        setOpenModalStatus(false);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    // console.log('dup 2');
                    // console.log(err.data.errorData);
                    // console.log(err.data.errorData.code);
                    // console.log(err.data.errorData.msg);
                    if (
                        err.data.errorData.msg ===
                        'ERROR DEPARTMENT CODE IS DUPLICATE'
                    ) {
                        form.setFields([
                            {
                                name: 'departmentCode',
                                errors: [
                                    t('userManagement.DepartmentCodeIsExist'),
                                ],
                            },
                        ]);
                    }
                    if (
                        err.data.errorData.msg ===
                        'ERROR DEPARTMENT NAME EN IS DUPLICATE'
                    ) {
                        form.setFields([
                            {
                                name: 'departmentEn',
                                errors: [
                                    t('userManagement.DepartmentNameIsExist'),
                                ],
                            },
                        ]);
                    }
                    if (
                        err.data.errorData.msg ===
                        'ERROR DEPARTMENT NAME TH IS DUPLICATE'
                    ) {
                        form.setFields([
                            {
                                name: 'departmentTh',
                                errors: [
                                    t('userManagement.DepartmentNameIsExist'),
                                ],
                            },
                        ]);
                    }
                });
        }
    };

    const disabled = historyName.includes('/view-department');

    // const onChange = (e) => {
    //     let { name, value } = e.target;
    //     if (name === 'departmentCode') {
    //         if (!value || (value && value.match(/[A-Z]/))) {
    //             setDeptCode(value);
    //             form.setFieldsValue({ departmentCode: value });
    //         } else {
    //             console.log(222);
    //             form.setFieldsValue({
    //                 departmentCode: deptCode,
    //             });
    //         }
    //     }
    // };

    return (
        <div className="bg-gray-body ">
            <div className="title flex">
                <div
                    className="cursor-pointer mr-3"
                    onClick={() =>
                        navigate(
                            `${ROUTER.CONFIGURATION.USER_MANAGEMENT}/department-list`
                        )
                    }
                >
                    <IconBack />
                </div>
                {historyName.includes('/view-department')
                    ? t('userManagement.departmentDetails')
                    : historyName.includes('/edit-department')
                    ? t('userManagement.editDepartment')
                    : t('Add Department')}
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {' '}
                    {t('common.Configuration')} /{t('User Management')} /{' '}
                    {t('Department List')} /
                </span>

                <span>
                    {' '}
                    {historyName.includes('/view-department')
                        ? t('userManagement.departmentDetails')
                        : historyName.includes('/edit-department')
                        ? t('userManagement.editDepartment')
                        : t('Add Department')}
                </span>
            </div>
            <div className="w-full m-auto">
                {/* <div className="text-xl py-12 px-4">
                    {t('landing.Please Select Activities below to')}
                    <strong> {t('landing.Begin Your Process')}</strong>
                </div> */}

                {/* <div className="container h-full mx-auto p-8 px-5 "> */}

                <div
                    className="content bg-white p-8 mt-6"
                    style={{ borderRadius: '6px' }}
                >
                    <div className="content pb-3">
                        <Form form={form} className="w-full" layout="vertical">
                            <Row
                                style={{
                                    borderBottom: '1px solid #F4F6FC',
                                    marginBottom: 20,
                                }}
                            >
                                <Col span={12} style={{ marginBottom: 20 }}>
                                    <div>
                                        <Row>
                                            <div
                                                className="title "
                                                style={{ color: '#7B67FB' }}
                                            >
                                                {t(
                                                    'userManagement.departmentInformation'
                                                )}
                                            </div>
                                        </Row>
                                    </div>
                                </Col>

                                <Col span={12} className="w-full">
                                    <Row>
                                        <Col span={24} className="w-full">
                                            <Row
                                                style={{
                                                    position: 'absolute',
                                                    right: 0,
                                                }}
                                            >
                                                <Button
                                                    disabled={disabled}
                                                    size="large"
                                                    htmlType="reset"
                                                    onClick={() =>
                                                        navigate(
                                                            `${ROUTER.CONFIGURATION.USER_MANAGEMENT}/department-list`
                                                        )
                                                    }
                                                    type="default"
                                                    className="text-purple-PHX border-purple-PHX w-full"
                                                    style={{
                                                        width: 120,
                                                        marginRight: 20,
                                                    }}
                                                >
                                                    {t('Cancel')}
                                                </Button>

                                                <Button
                                                    disabled={disabled}
                                                    size="large"
                                                    onClick={onSubmit}
                                                    htmlType="submit"
                                                    type="primary"
                                                    className="w-full"
                                                    style={{ width: 120 }}
                                                >
                                                    {t('Save')}
                                                </Button>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>

                            <div className="grid">
                                <div className="grid grid-cols-3 gap-12">
                                    <Form.Item
                                        label={t('userManagement.departmentEn')}
                                        name="departmentEn"
                                        colon={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: t(
                                                    'errorText.requiredField'
                                                ),
                                            },
                                            {
                                                whitespace: true,
                                                message: t(
                                                    'errorText.requiredField'
                                                ),
                                            },
                                        ]}
                                    >
                                        <Input
                                            disabled={disabled}
                                            size="large"
                                            placeholder={t(
                                                'userManagement.departmentEn'
                                            )}
                                            showCount
                                            maxLength={255}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label={t('userManagement.departmentTh')}
                                        name="departmentTh"
                                        colon={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: t(
                                                    'errorText.requiredField'
                                                ),
                                            },
                                            {
                                                whitespace: true,
                                                message: t(
                                                    'errorText.requiredField'
                                                ),
                                            },
                                        ]}
                                    >
                                        <Input
                                            disabled={disabled}
                                            size="large"
                                            placeholder={t(
                                                'userManagement.departmentTh'
                                            )}
                                            showCount
                                            maxLength={255}
                                        />
                                    </Form.Item>
                                </div>

                                <div className="grid grid-cols-3 gap-12 relative">
                                    <Form.Item
                                        className="col-span-2"
                                        label={t(
                                            'userManagement.departmentCode'
                                        )}
                                        name="departmentCode"
                                        colon={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: t(
                                                    'errorText.requiredField'
                                                ),
                                            },
                                            {
                                                whitespace: true,
                                                message: t(
                                                    'errorText.requiredField'
                                                ),
                                            },
                                            {
                                                pattern: new RegExp(
                                                    /[A-Z]$/g
                                                    // /[A-Z]{3,}$/g
                                                ),
                                                message: t(
                                                    'userManagement.InvalidFormatSpecifyDeptCode'
                                                ),
                                            },
                                        ]}
                                    >
                                        <Input
                                            // name="departmentCode"
                                            disabled={isDeptDisable}
                                            size="large"
                                            placeholder={t(
                                                'userManagement.departmentCode'
                                            )}
                                            showCount
                                            maxLength={5}
                                            // onChange={(e) => onChange(e)}
                                        />
                                    </Form.Item>

                                    <div
                                        className={`absolute cursor-pointer`}
                                        style={{
                                            top: '-8px',
                                            left: `${
                                                lang === 'en'
                                                    ? '9rem'
                                                    : '4.5rem'
                                            }`,
                                            // cursor: 'pointer',
                                        }}
                                    >
                                        <Tooltip
                                            placement="bottom"
                                            title={t(
                                                'userManagement.HoverIconDepartmentCode'
                                            )}
                                            overlayStyle={{ width: '32%' }}
                                        >
                                            <span className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple">
                                                <ExclamationCircleOutlined />
                                            </span>
                                        </Tooltip>
                                    </div>
                                </div>
                                <div className="grid grid-cols-3 gap-12">
                                    <Form.Item
                                        className="col-span-2"
                                        label={t(
                                            'userManagement.detailOfDepartment'
                                        )}
                                        name="departmentDetail"
                                        colon={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: t(
                                                    'errorText.requiredField'
                                                ),
                                            },
                                            {
                                                whitespace: true,
                                                message: t(
                                                    'errorText.requiredField'
                                                ),
                                            },
                                        ]}
                                    >
                                        <TextArea
                                            disabled={disabled}
                                            style={{ height: 100 }}
                                            placeholder={t(
                                                'userManagement.detailOfDepartment'
                                            )}
                                            showCount
                                            maxLength={150}
                                        />
                                    </Form.Item>
                                </div>
                            </div>

                            {historyName.includes('/view-department') ? (
                                <Row className="mt-8">
                                    <Col span={24}>
                                        <Row>
                                            <div className="font-bold">
                                                {t('Member')}
                                            </div>
                                        </Row>
                                        <Row className="mb-8">
                                            <span className="text-sm text-gray-400">
                                                {t('TotalItems', {
                                                    length: listMember.length,
                                                })}
                                            </span>
                                        </Row>
                                    </Col>
                                </Row>
                            ) : null}
                            {historyName.includes('/view-department') ? (
                                <>
                                    {listMember?.map((res) => (
                                        <Row
                                            style={{
                                                backgroundColor: '#F9FAFE',
                                                marginBottom: 15,
                                                height: 70,
                                            }}
                                        >
                                            <Col span={1} className="mt-2">
                                                <div
                                                    style={{
                                                        backgroundColor:
                                                            '#F4EEFE',
                                                        height: 30,
                                                        width: 30,
                                                        borderRadius: 15,
                                                        paddingTop: 3,
                                                        marginTop: 5,
                                                        marginLeft: 10,
                                                    }}
                                                >
                                                    <Avatar
                                                        style={{
                                                            backgroundColor:
                                                                '#EEE5FF',
                                                            color: '#7B67FB',
                                                        }}
                                                    >
                                                        {res.fullName || '-'}
                                                    </Avatar>
                                                </div>
                                            </Col>
                                            <Col span={21} className="mt-2">
                                                <Row>
                                                    <div className="font-bold">
                                                        {res.fullName || '-'}
                                                    </div>
                                                </Row>
                                                <Row className="mt-2">
                                                    <span className="text-sm text-gray-400">
                                                        <span className="font-semibold">
                                                            {t('Phone Number')}
                                                        </span>{' '}
                                                        :{' '}
                                                        {res.phoneNumber || '-'}
                                                    </span>
                                                    &nbsp; &nbsp;
                                                    <span className="text-sm text-gray-400">
                                                        <span className="font-semibold">
                                                            {t('Email')}
                                                        </span>{' '}
                                                        : {res.email || '-'}
                                                    </span>
                                                    &nbsp; &nbsp;
                                                    <span className="text-sm text-gray-400">
                                                        <span className="font-semibold">
                                                            {t('StaffID')}
                                                        </span>{' '}
                                                        : {res.staffId || '-'}
                                                    </span>
                                                    &nbsp; &nbsp;
                                                    <span className="text-sm text-gray-400">
                                                        <span className="font-semibold">
                                                            {t('Role')}
                                                        </span>{' '}
                                                        : {res.role || '-'}
                                                    </span>
                                                    &nbsp; &nbsp;
                                                </Row>
                                            </Col>
                                        </Row>
                                    ))}
                                </>
                            ) : null}
                        </Form>
                    </div>
                </div>
                {/* </div> */}
            </div>
            {openModalStatus && (
                <ModalSuccess
                    open={openModalStatus}
                    handelClose={() => {
                        setOpenModalStatus(undefined);
                        navigate(
                            `${ROUTER.CONFIGURATION.USER_MANAGEMENT}/department-list`
                        );
                    }}
                    handelOk={() => {
                        setOpenModalStatus(undefined);
                        navigate(
                            `${ROUTER.CONFIGURATION.USER_MANAGEMENT}/department-list`
                        );
                    }}
                    text={t('common.SaveData')}
                />
            )}
            <ModalFail
                open={openModalStatus === false}
                handelClose={() => {
                    setOpenModalStatus(undefined);
                }}
                handelOk={() => {
                    setOpenModalStatus(undefined);
                }}
                text={t('userManagement.FailedtoSubmitData')}
            />
        </div>
    );
};

export default AddDepartmentPage;
